import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid, clearCredentials } from '../services/authUtils';

export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const token = localStorage.getItem('token');
  const userName = localStorage.getItem('userName');

  if (!token || !userName || !isTokenValid(token)) {
    clearCredentials();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
